import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Panel, PanelHeader, PanelBody } from "../../../../components/panel/panel";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import * as formik from "formik";
import * as yup from "yup";
import Swal from "sweetalert2";
import {
  createSerieContado,
  createSerieCredito,
  getSeriesBySocialReason,
} from "../../../../services/CatalogService";
import { serieValidationSchema } from "./formConfigSerie/SerieValidation";
import SerieFields from "./formConfigSerie/SerieFields";

function ConfigSerieVaroExpress() {
  const razonSocial = 'VaroExpress';

  const { Formik } = formik;
  const [initialValues, setInitialValues] = useState({
    serieContado: "",
    serieCredito: "",
  });


  useEffect(() => {
    async function fetchSeries() {
      try {
        const data = await getSeriesBySocialReason(razonSocial);
        const contado = data.find((s) => s.type === "Contado");
        const credito = data.find((s) => s.type === "Credito");
        setInitialValues({
          serieContado: contado?.prefix || "",
          serieCredito: credito?.prefix || "",
        });
      } catch (err) {
        console.error("Error cargando series existentes", err);
      }
    }

    fetchSeries();
  }, []);

  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Inicio</Link>
            </li>
            <li className="breadcrumb-item">Configuración</li>
            <li className="breadcrumb-item active">Series</li>
          </ol>
          <h1 className="page-header mb-0">Configurar series - Varo Express</h1>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-xl-12">
          <Panel>
            <PanelHeader>Registro de Series</PanelHeader>
            <PanelBody>
              <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={serieValidationSchema}

                onSubmit={async (values, { setSubmitting }) => {
                  try {
                    await Promise.all([
                      createSerieContado({ prefix: values.serieContado }, razonSocial),
                      createSerieCredito({ prefix: values.serieCredito }, razonSocial),
                    ]);

                    Swal.fire({
                      title: "Éxito",
                      text: "Series guardadas correctamente",
                      icon: "success",
                      confirmButtonText: "Cerrar",
                    });
                  } catch (error) {
                    const msg =
                      error.response?.data?.message ||
                      "Error al guardar las series";
                    Swal.fire({
                      title: "Error",
                      text: msg,
                      icon: "error",
                      confirmButtonText: "Cerrar",
                    });
                  } finally {
                    setSubmitting(false);
                  }
                }}
              >
                {({ handleSubmit, handleChange, values, touched, errors }) => (
                  <SerieFields
                    values={values}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                    errors={errors}
                    touched={touched}
                  />
                )}
              </Formik>
            </PanelBody>
          </Panel>
        </div>
      </div>
    </div>
  );
}

export default ConfigSerieVaroExpress;
